import cn from 'classnames'
import React, { FC, useState, useEffect, useRef, useMemo } from 'react'
import s from './Input.module.css'
import Image from 'next/image'
import Warning from '@components/warning'
import { IField, ILabel } from 'types/Form'
import Label from '../label'

interface ISelectSearch extends IField {
   required?: boolean,
   name: string,
   id: string,
   type: string,
   className?: string,
   onChange: (value: string) => void,
   label?: Omit<ILabel, "id">
   options: { label: string, value: string }[];
   disabled?: boolean;
}

export const SelectSearch: FC<ISelectSearch> = ({ options, className, type, id, required, name, onChange, warning, ready, label, value, disabled }) => {
   const [currentValue, setCurrentValue] = useState('')
   const [selectedLabel, setSelectedLabel] = useState('')
   const [opened, setOpened] = useState(false);
   const selectRef = useRef<HTMLDivElement>(null);

   const [searchInput, setSearchInput] = useState('');
   const [filteredOptions, setFilteredOptions] = useState(options);

   const [fr, setFr] = useState(false);

   useEffect(() => {
      if (fr) {
         onChange(currentValue);
      }
      setOpened(false);
   }, [currentValue])

   useEffect(() => {
      setOpened(false);
   }, [selectedLabel])

   useEffect(() => {
      if (currentValue == '' && value != "") {
         console.log("Value:", value);
         const optionFound = options.find(e => e.value == value);

         if (optionFound && optionFound.label && optionFound.value) {
            setCurrentValue(optionFound.value);
            setSelectedLabel(optionFound.label);
            setSearchInput(optionFound.label);
         }
      }
   }, [value, options])

   const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const filtered = options.filter(op => {
         if (op.label) {
            return op.label.toLowerCase().includes(e.target.value.toLowerCase())
         }
      });
      setFilteredOptions(filtered);
      setSearchInput(e.target.value);
   }

   const handleClickInputChange = (event: React.MouseEvent<HTMLInputElement>) => {
      let target = event.target as HTMLInputElement;
      let searchText = '';

      if (target && target.value) {
         searchText = target.value;
      }
      const filtered = options.filter(op => {
         if (op.label) {
            return op.label.toLowerCase().includes(searchText.toLowerCase());
         }
      });
      setFilteredOptions(filtered);
      setSearchInput(searchText);
   }

   useEffect(() => {
      setFr(true);
      if (options && options.length > 0) {
         document.addEventListener('click', (e) => {
            e.stopPropagation();
            if (disabled) {
               setOpened(false);
            } else if (selectRef.current?.contains(e.target as Node)) {
               setFilteredOptions(options);
               setOpened(true);
            } else {
               setOpened(false);
            }
         });
      }
   }, [options])

   useEffect(() => {
      if (value === '') {
         setSelectedLabel('');
         setSearchInput('');
         setCurrentValue('');
         setFilteredOptions(options);
      }
   }, [options])

   return <div className={cn(s.root, className)}>
      {label ? <Label
         {...label}
         id={id}
      /> : null}
      <div ref={selectRef}>
         <input className={cn(s.hide)}
            name={name}
            required={required}
            type={type}
            id={id}
            defaultValue={currentValue}
            disabled={disabled}
         />
         <div style={{ padding: '0 10px 0 0' }} className={cn(s.input)}>
            <div className={cn(s.selectLabel)}>
               <input
                  style={{ border: 'none', outline: 'none' }}
                  className={cn(s.input)}
                  value={searchInput}
                  onChange={handleInputChange}
                  disabled={disabled}
               />
               {!disabled && <Image
                  src="/assets/onboarding/inputs/selector.png"
                  width="11"
                  height="6"
                  layout="fixed"
               />}
            </div>
            {<div className={cn(s.menu, { [s.hide]: opened == false })}>
               {!disabled && filteredOptions.map(option => <div
                  key={option.value}
                  className={cn(s.option, { [s.selected]: selectedLabel == option.label })}
                  onClick={(e) => { setOpened(false); setCurrentValue(option.value); setSelectedLabel(option.label); setSearchInput(option.label); e.stopPropagation(); setOpened(false); }}
               >
                  {option.label}
               </div>)}
            </div>}
         </div>
         <Warning warning={warning} />
      </div>
   </div>
}

